module.exports = __webpack_public_path__ + "stylesheets/global_1a90c87d4401c692c73f7ac195c53724.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/global.less
// module id = x7Q4
// module chunks = 153